// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBcGw8AhxPYSO7-PDQONgYgdQBYRTNx7OQ",
  authDomain: "alzguard-99937.firebaseapp.com",
  projectId: "alzguard-99937",
  storageBucket: "alzguard-99937.firebasestorage.app",
  messagingSenderId: "282700226008",
  appId: "1:282700226008:web:8c5b647fb7dd1b106366ad",
  measurementId: "G-P2PV13X11R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);